 
import http from "@/http/service"
 
const Relatorio = (params={})=> {
    return http.get(`/parceiro/relatorio`, {params})

}
  
export default {
    Relatorio,    
}